import { useTheme } from "@mui/material/styles";

/**
 * Custom MUI Theme Palette Hook
 * Returns the current MUI theme with custom color extensions
 */
const MuiThemePalette = () => {
  const theme = useTheme();

  // Extend the theme with custom properties if they don't exist
  return {
    ...theme,
    custom: {
      primary_icon: theme.palette?.primary?.main || "#0967D2",
      heading: theme.palette?.primary?.contrastText || "#FFFFFF",
      secondary_icon: theme.palette?.secondary?.main || "#DE911D",
      background: theme.palette?.background?.paper || "#FFFFFF",
      text: theme.palette?.text?.primary || "#000000",
      ...theme.custom, // Preserve any existing custom properties
    },
  };
};

export default MuiThemePalette;
